import { gql } from "@apollo/client";

import { ActionFormDialog } from "controls";
import { useAction, useData } from "hooks";
import { FolderInput, ItemsInput } from "inputs";

export default function MoveItemsDialog({ itemIds, folderId, ...others }) {
  const data = useData(
    gql`
      query MoveItemsDialog($itemId: ID) {
        item(id: $itemId) {
          id
          ancestorFolder {
            id
          }
        }
      }
    `,
    { itemId: itemIds[0] },
  );

  const moveItems = useAction(gql`
    mutation MoveItemsDialog($input: MoveItemsInput!) {
      moveItems(input: $input) {
        sourceFolders {
          id
          items {
            id
          }
        }
        destinationFolder {
          id
          items {
            id
          }
        }
      }
    }
  `);

  return (
    <ActionFormDialog
      {...others}
      title="移动文件"
      fields={[
        {
          name: "itemIds",
          label: "移动文件",
          value: itemIds,
          required: true,
          readOnly: true,
          inputComponent: ItemsInput,
        },
        {
          name: "destinationFolderId",
          label: "目标目录",
          required: true,
          inputComponent: FolderInput,
          value: folderId,
          options: { topFolderId: data?.item.ancestorFolder.id },
        },
      ]}
      onSubmit={async (formData) => {
        await moveItems({
          input: {
            itemIds,
            ...formData,
          },
        });
      }}
    />
  );
}
